import React from "react";
import {
  getDocsReceivedPercentage,
  ISigningAppointmentScanbackManifest
} from "../../../../../../../types/signingAppointment/ISigningAppointmentScanbackManifest";
import { ProgressBarTW } from "../../../../../../../tailwindComponents/progressBarTW/ProgressBarTW";

export const IncomingDocumentsProgress = ({ manifest }: { manifest: ISigningAppointmentScanbackManifest }) => {
  const progressPercent = getDocsReceivedPercentage(manifest);
  const label = `${manifest.documentsReceived} of ${manifest.totalDocuments} Documents Received`;

  return <ProgressBarTW percentage={progressPercent} label={label} />;
}